var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usage-box"},_vm._l((_vm.list),function(item,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(item.name+' #'+item.num+": "+item.t_usage+item.unit)+" ; ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }